module.exports = __webpack_public_path__ + "static/media/motor.d72748c8.svg";